import { useWindowSize } from "@vueuse/core";
import { computed, reactive } from "vue";
const size = reactive(useWindowSize());

const isScreenMS = computed(() =>  size.width <= 320);  // Mobile small
const isScreenMM = computed(() =>  size.width <= 375);  // Mobile middle
const isScreenML = computed(() =>  size.width <= 425);  // Mobile large
const isScreenT = computed(() =>  size.width <= 768);   // Tablet
const isScreenL = computed(() =>  size.width <= 1024);  // Laptop
const isScreenLL = computed(() =>  size.width <= 1440); // Laptop large

export {
  isScreenMS,
  isScreenMM,
  isScreenML,
  isScreenT,
  isScreenL,
  isScreenLL,
}
